import React from 'react';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { RegionalData } from './RegionalData';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { Wrapper } from './RegionalData.styles';
import { STATES_MAP_CODES } from '../utils';
import { getInvestigateRegionsData } from 'utils/apiRequests';
import isEqual from 'lodash/isEqual';
import { SettingsContext } from 'contexts/SettingsContext';

export class RegionalDataContainer extends React.Component {
	state = {
		data: [],
		isLoading: false,
	};

	componentDidMount() {
		this.fetchData();
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	componentDidUpdate(prevProps) {
		const {
			dimension,
			queryParams,
			selectedCountry,
			selectedState,
			selectedItem,
		} = this.props;

		if (
			selectedCountry !== prevProps.selectedCountry ||
			selectedState !== prevProps.selectedState ||
			selectedItem !== prevProps.selectedItem ||
			dimension.value !== prevProps.dimension.value ||
			!isEqual(queryParams, prevProps.queryParams)
		) {
			this.fetchData();
		}
	}

	getApiParams = () => {
		const {
			dimension,
			queryParams,
			selectedCountry,
			selectedState,
			selectedItem,
			spendBy,
		} = this.props;
		const isPurchasing = dimension.value === 'purchasing';
		const countryFilter = `${dimension.value}Country`;
		const stateFilter = `${dimension.value}State`;
		const showState = !!STATES_MAP_CODES[selectedCountry];

		return {
			...queryParams,
			isPurchasing,
			filters: [
				...queryParams.filters,
				...(selectedCountry ? [countryFilter] : []),
				...(selectedState ? [stateFilter] : []),
				...(selectedItem ? [spendBy] : []),
			],
			filterValues: [
				...queryParams.filterValues,
				...(selectedCountry ? [selectedCountry] : []),
				...(selectedState ? [selectedState] : []),
				...(selectedItem ? [selectedItem] : []),
			],
			includeState: showState,
		};
	};

	fetchData = () => {
		this.setState({ isLoading: true });

		return getInvestigateRegionsData(this.getApiParams())
			.then(data => {
				if (this.unmounted) return;
				this.setState({
					data,
					isLoading: false,
				});
			})
			.catch(() => {
				if (this.unmounted) return;
				this.setState({ isLoading: false });
			});
	};

	handleExport = () => {
		const { onExport, selectedCountry } = this.props;
		const showState = !!STATES_MAP_CODES[selectedCountry];

		onExport({
			...this.getApiParams(),
			includeState: showState,
		});
	};

	render() {
		const { isLoading, data } = this.state;
		const {
			currencySymbol,
			selectedCountry,
			selectedState,
			queryParams,
			spendType,
			dimension,
			showExplorePage,
			spendBy,
			selectedItem,
			hideDecimals,
		} = this.props;

		if (isLoading) {
			return (
				<Wrapper>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</Wrapper>
			);
		}

		return (
			<RegionalData
				data={data}
				currencySymbol={currencySymbol}
				selectedCountry={selectedCountry}
				selectedState={selectedState}
				queryParams={queryParams}
				spendType={spendType}
				dimension={dimension}
				onExport={this.handleExport}
				showExplorePage={showExplorePage}
				spendBy={spendBy}
				selectedItem={selectedItem}
				hideDecimals={hideDecimals}
			/>
		);
	}
}

export default props => (
	<QueryStringContext.Consumer>
		{({ spendType, spendBy, selectedItem }) => (
			<SettingsContext.Consumer>
				{({ hideDecimals }) => (
					<RegionalDataContainer
						hideDecimals={hideDecimals}
						spendType={
							Number(spendType) || Number(spendType) === 0
								? Number(spendType)
								: undefined
						}
						spendBy={spendBy}
						selectedItem={selectedItem}
						{...props}
					/>
				)}
			</SettingsContext.Consumer>
		)}
	</QueryStringContext.Consumer>
);
